import { useState, useEffect } from "react";
import {
  Grid,
  TextField,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  MenuItem,
  Divider,
  TextFielDecimalNumbers,
  Autocomplete,
  Switch,
  DatePicker,
  TimePicker,
  FormControl,
  Select,
  Chip,
  Box,
  Paper,
  Tabs,
  Tab,
  CardContent,
  Loading,
  TabPanel,
} from "../../../components";
import { AddLayout } from "../../../layouts";
import {
  GrupoPessoasService,
  MeioPagamentoService,
  PessoaService,
  ProdutosService,
  TabelaVendaService,
  notification,
} from "../../../services";
import {
  formatDate,
  responseErros,
  unformatPrice,
  userLogs,
  voltar,
} from "../../../utils";
import { InputErros, PermisoesHelper, value } from "../../../helpers";
import { format, isValid } from "date-fns";
import FiltroProdutosDialog from "./components/filtro-produtos-dialog.component";
import { TabelaVenda } from "./entities";
import { tabelaVendaValidator } from "./middlewares";
import { useImportContext } from "../../../contexts/import.context";
import { TabelaVendaItens } from "./tabs";
import TabelaVendaClientes from "./tabs/clientes-tab.component";

const produtosService = new ProdutosService();
const meioPagamentoService = new MeioPagamentoService();
const gruposPessoasService = new GrupoPessoasService();
const tabelaVendaService = new TabelaVendaService();
const pessoasService = new PessoaService();
const permissoesHelper = new PermisoesHelper();
let tabelaVendaEntity = new TabelaVenda({
  ativado: true,
  tipoTabela: "POR_PRODUTO",
  operacao: "somar",
  dataInicio: null,
  dataFim: null,
  diasSemana: [0, 1, 2, 3, 4, 5, 6,]
});

const TabelaVendaView = ({ match }) => {
  const { id } = match.params;
  const { initialCollapses } = useImportContext();
  const [produtos, setProdutos] = useState([]);
  const [produto, setProduto] = useState(null);
  const [tabelaProdutos, setTabelaProdutos] = useState([]);
  const [tabelaClientes, setTabelaClientes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [abaValue, setAbaValue] = useState(0);
  const [filtros, setFiltros] = useState({});
  const [tabelaVenda, setTabelaVenda] = useState({ ...tabelaVendaEntity });
  const [open, setOpen] = useState(false);
  const [meioPagamentoList, setMeioPagamentoList] = useState([]);
  const [grupoPessoaList, setGrupoPessoaList] = useState([]);
  const [isProdutoEdit, setIsProdutoEdit] = useState(false);
  const [inputErro, setInputErro] = useState([]);
  const [userLog, setUserLog] = useState({});
  const inputErros = new InputErros(inputErro, setInputErro);
  const diasSemana = [
    {
      label: "Segunda-Feira",
      value: 1,
    },
    {
      label: "Terça-Feira",
      value: 2,
    },
    {
      label: "Quarta-Feira",
      value: 3,
    },
    {
      label: "Quinta-Feira",
      value: 4,
    },
    {
      label: "Sexta-Feira",
      value: 5,
    },
    {
      label: "Sábado",
      value: 6,
    },
    {
      label: "Domingo",
      value: 0,
    },
  ];

  const [diasSelecionados, setDiasSelecionados] = useState([
    0, 1, 2, 3, 4, 5, 6,
  ]);

  async function buscarDados() {
    buscarMeiosPagamento();
    buscarGruposPessoas();
  }

  useEffect(() => {
    buscarDados();
    if (!id) {
      tabelaVendaEntity = new TabelaVenda(tabelaVendaEntity);
    } else {
      buscarTabelaVenda();
    }
  }, []);

  const buscarTabelaVenda = async () => {
    if (!id) return;
    setLoading(true);
    try {
      const tabelaVendaData = await obterDadosTabelaVenda(id);
      if (!tabelaVendaData) return;
      inicializarTabelaVenda(tabelaVendaData);
      await carregarRelacionamentos(tabelaVendaData);
    } catch (error) {
      console.error("Erro ao buscar tabela venda:", error);
    } finally {
      setLoading(false);
    }
  };

  async function onClickLog() {
    if ("userCreatedLog" in userLog) return;
    const logs = await userLogs(tabelaVenda);
    setUserLog(logs);
  }

  const obterDadosTabelaVenda = async (id) => {
    const result = await tabelaVendaService.getById(id);
    if (result.isAxiosError) {
      responseErros(result);
      return null;
    }
    return result.data;
  };

  const inicializarTabelaVenda = (data) => {
    tabelaVendaEntity = new TabelaVenda(data, id);
    setTabelaVenda({ ...tabelaVendaEntity });
    setTabelaProdutos(data.itens || []);
    setDiasSelecionados(data.diasSemana || []);
  };

  const carregarRelacionamentos = async (data) => {
    const produtos = data.itens || [];
    const pessoas = data.pessoaIds || [];
    await Promise.allSettled([
      buscarProdutosRelacionados(produtos),
      buscarPessoasRelacionadas(pessoas),
    ]);
  };

  const buscarProdutosRelacionados = async (tabelaProdutos) => {
    if (!tabelaProdutos?.length) return;
    try {
      const produtosEnriquecidos = await buscarDadosProdutos(tabelaProdutos);
      updateStateProdutos(produtosEnriquecidos);
    } catch (error) {
      console.error("Erro ao carregar produtos relacionados:", error);
    }
  };

  const buscarDadosProdutos = async (tabelaProdutos) => {
    const produtosIds = tabelaProdutos.map((produto) => produto.estProdutoId);
    const filtros = { id: produtosIds, nonPaginated: true };
    const result = await produtosService.getAll(filtros);
    if (result.isAxiosError) {
      responseErros(result);
      return [];
    }
    return preencherProdutosInformacoes(tabelaProdutos, result.data);
  };

  const preencherProdutosInformacoes = (tabelaProdutos, produtosInfo) => {
    const produtosMap = mapeamentoProdutoInformacao(produtosInfo);
    return tabelaProdutos.map((produto) => ({
      ...produto,
      ...produtosMap[produto.estProdutoId],
    }));
  };

  const mapeamentoProdutoInformacao = (produtos) => {
    return produtos.reduce((acc, produto) => {
      acc[produto.id] = {
        ...produto,
        ...(produto.informacao || {}),
        id: produto.id,
      };
      return acc;
    }, {});
  };

  const updateStateProdutos = (produtosEnriquecidos) => {
    setTabelaProdutos(produtosEnriquecidos);
    tabelaVendaEntity.setChangeItens(produtosEnriquecidos);
    setTabelaVenda({ ...tabelaVendaEntity });
    setProdutos(produtosEnriquecidos);
  };

  const buscarPessoasRelacionadas = async (pessoaIds) => {
    if (!pessoaIds?.length) return;
    const pessoasIds = pessoaIds.map((pessoa) => pessoa.intPessoaId);
    const filtros = { id: pessoasIds, nonPaginated: true };
    const result = await pessoasService.getAll(filtros);
    if (!result.isAxiosError) {
      setTabelaClientes(result.data);
    } else {
      responseErros(result);
    }
  };

  const buscarMeiosPagamento = () => {
    const filtro = {
      nonPaginated: true,
      ativado: true,
    };
    meioPagamentoService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        setMeioPagamentoList(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarGruposPessoas = () => {
    const filter = {
      nonPaginated: true,
      ativado: true,
    };
    gruposPessoasService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setGrupoPessoaList(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const handleSubmit = async () => {
    setLoading(true);
    tabelaVendaValidator
      .validate(tabelaVendaEntity, { abortEarly: false })
      .then(async () => {
        if (id) {
          const response = await tabelaVendaService.atualizar(
            id,
            tabelaVendaEntity
          );
          setLoading(false);
          if (!response.isAxiosError) {
            notification.alteracaoSucesso();
            voltar();
          } else {
            responseErros(response);
          }
        } else {
          const response = await tabelaVendaService.cadastrar(
            tabelaVendaEntity
          );
          setLoading(false);
          if (!response.isAxiosError) {
            notification.cadastroSucesso();
            initialCollapses();
            voltar();
          } else {
            responseErros(response);
          }
        }
      })
      .catch((err) => {
        setLoading(false);
        inputErros.set(err);
      });
  };

  const resetForm = () => {
    setFiltros({});
    setTabelaVenda((prevState) => ({
      ...prevState,
      operacao: "somar",
      fator: null,
      quantidadeMinima: null,
      precoPraticado: null,
    }));
    setProdutos([]);
    setProduto(null);
    setIsProdutoEdit(false);
  };

  const handleOperacaoChange = (e) => {
    tabelaVendaEntity.setOperacao(e.target.value, produto?.precoVenda);
    setTabelaVenda({ ...tabelaVendaEntity });
  };

  const handleAjusteChange = (e) => {
    let value = e.target.value;
    if (e.target.name !== "quantidadeMinima") {
      value = unformatPrice(value);
    }
    if (e.target.name == "fator") {
      tabelaVendaEntity.setFator(
        value,
        produto?.precoVenda || tabelaVendaEntity.precoAtual
      );
      setTabelaVenda({ ...tabelaVendaEntity });
      return;
    }
    if (e.target.name == "precoPraticado") {
      tabelaVendaEntity.setHandleChangeInput(e.target.name, value);
      tabelaVendaEntity.setFator(
        tabelaVendaEntity.fator,
        produto?.precoVenda || tabelaVendaEntity.precoAtual
      );
      setTabelaVenda({ ...tabelaVendaEntity });
      return;
    }
    tabelaVendaEntity.setHandleChangeInput(e.target.name, value);
    setTabelaVenda({ ...tabelaVendaEntity });
  };

  const handleInputChange = (e) => {
    tabelaVendaEntity.setHandleChangeInput(e.target.name, e.target.value);
    setTabelaVenda({ ...tabelaVendaEntity });
  };

  const handleChangeSwitch = (event) => {
    tabelaVendaEntity.setHandleChangeSwitch(
      event.target.name,
      event.target.checked
    );
    setTabelaVenda({ ...tabelaVendaEntity });
  };

  const handleDateTimeChange = (name, date, type = "data") => {
    if (!isValid(date)) {
      tabelaVendaEntity.setHandleChangeInput(name, null);
      setTabelaVenda({ ...tabelaVendaEntity });
      return;
    }

    let value;
    if (type === "hora") {
      value = format(date, "HH:mm");
    } else {
      value = formatDate.toSend(date);
    }
    tabelaVendaEntity.setHandleChangeInput(name, value);
    setTabelaVenda((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeMultipleAutoComplete = (name, values) => {
    tabelaVendaEntity.setHandleChangeAutoCompleteMultiSelecting(name, values);
    setTabelaVenda({ ...tabelaVendaEntity });
  };

  const handleChangeAutocomplete = (name, value) => {
    tabelaVendaEntity.setHandleChangeAutoComplete(name, value);
    setTabelaVenda({ ...tabelaVendaEntity });
  };

  const handleSelecaoDia = (dia) => {
    const dias = [...diasSelecionados];
    if (dias.includes(dia)) {
      setDiasSelecionados(dias.filter((d) => d !== dia));
    } else {
      setDiasSelecionados([...dias, dia]);
    }
    tabelaVendaEntity.setHandleChangeAutoCompleteMultiSelecting(
      "diasSemana",
      diasSelecionados.includes(dia)
        ? diasSelecionados.filter((d) => d !== dia)
        : [...diasSelecionados, dia]
    );
    setTabelaVenda({ ...tabelaVendaEntity });
  };

  function tabProps(index) {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
    };
  }

  return (
    <AddLayout
      id={id}
      title={id ? "Editar Tabela de Venda" : "Cadastrar Tabela de Venda"}
      loading={loading}
      onClickSalvar={handleSubmit}
      userLog={id ? userLog : null}
      onClickLog={onClickLog}
      showUpdate={!id || permissoesHelper.temPermisao("tabelas-venda-editar")}
      actions={
        <FormControlLabel
          control={
            <Switch
              id="ativado"
              name="ativado"
              checked={tabelaVenda?.ativado ? tabelaVenda.ativado : false}
              onChange={handleChangeSwitch}
              color="primary"
            />
          }
          label={tabelaVenda?.ativado ? "Ativado" : "Desativado"}
        />
      }
    >
      <Typography variant="body2" gutterBottom sx={{ mb: 2 }}>
        Identificação
      </Typography>

      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={6}>
          <TextField
            id="descricao"
            name="descricao"
            label="Descricao"
            variant="outlined"
            value={tabelaVenda?.descricao ? tabelaVenda.descricao : ""}
            onChange={(event) => {
              setInputErro([]);
              handleInputChange(event);
            }}
            fullWidth
            required
            error={inputErros.get("descricao")}
          />
        </Grid>

        <Grid item xs={3}>
          <Autocomplete
            id="intGrupoPessoaId"
            name="intGrupoPessoaId"
            options={grupoPessoaList}
            autoHighlight
            getOptionLabel={(option) => option?.nome || ""}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Grupo de Pessoa"
                variant="outlined"
                error={inputErros.get("intGrupoPessoaId")}
              />
            )}
            onChange={(e, value) =>
              handleChangeAutocomplete("intGrupoPessoaId", value)
            }
            value={value.autoComplete(
              grupoPessoaList,
              tabelaVenda?.intGrupoPessoaId
            )}
          />
        </Grid>

        <Grid item xs={3}>
          <Select
            id="tipoTabela"
            name="tipoTabela"
            value={tabelaVenda?.tipoTabela}
            label="Tipo Tabela"
            onChange={(event) => handleInputChange(event)}
            fullWidth
            required
            error={inputErros.get("tipoTabela")}
          >
            <MenuItem value={"POR_PRODUTO"}>Por Produto</MenuItem>
            <MenuItem value={"TODOS_PRODUTOS"}>Todos Produtos</MenuItem>
          </Select>
        </Grid>

        <Grid item xs={6} sm={3}>
          <DatePicker
            id="dataInicio"
            name="dataInicio"
            label="Data Inicial"
            format="dd/MM/yyyy"
            value={value.date(tabelaVenda?.dataInicio)}
            onChange={(date) => handleDateTimeChange("dataInicio", date)}
          />
        </Grid>
        <Grid item xs={6} sm={3}>
          <TimePicker
            id="horaInicio"
            name="horaInicio"
            label="Hora Inicial"
            format="HH:mm"
            value={value.time(tabelaVenda?.horaInicio)}
            onChange={(date) =>
              handleDateTimeChange("horaInicio", date, "hora")
            }
          />
        </Grid>

        <Grid item xs={6} sm={3}>
          <DatePicker
            id="dataFim"
            name="dataFim"
            label="Data Final"
            format="dd/MM/yyyy"
            value={value.date(tabelaVenda?.dataFim)}
            onChange={(date) => handleDateTimeChange("dataFim", date)}
          />
        </Grid>
        <Grid item xs={6} sm={3}>
          <TimePicker
            id="horaFim"
            name="horaFim"
            label="Hora Final"
            format="HH:mm"
            value={value.time(tabelaVenda?.horaFim)}
            onChange={(date) => handleDateTimeChange("horaFim", date, "hora")}
          />
        </Grid>

        <Grid item xs={6}>
          <FormControl variant="outlined" fullWidth>
            <Autocomplete
              multiple
              name="tabelaMeiosPagamento"
              noOptionsText="Sem opções"
              options={meioPagamentoList}
              autoHighlight
              getOptionLabel={(option) =>
                option?.descricao ? option.descricao : ""
              }
              onChange={(_, newValue) => {
                handleChangeMultipleAutoComplete("meioPagamentoIds", newValue);
              }}
              value={value.multiple(
                meioPagamentoList,
                tabelaVenda?.meioPagamentoIds
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="Meios de Pagamento"
                  error={inputErros.get("tabelaMeiosPagamento")}
                />
              )}
            />
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 1,
              justifyContent: "space-between",
              alignItems: "center",
              mt: 1,
            }}
          >
            {diasSemana.map((dia) => (
              <Chip
                key={dia.value}
                label={dia.label}
                clickable
                onClick={() => handleSelecaoDia(dia.value)}
                color={
                  diasSelecionados.includes(dia.value) ? "primary" : "default"
                }
                variant={
                  diasSelecionados.includes(dia.value) ? "filled" : "outlined"
                }
                sx={{
                  fontSize: {
                    xs: "0.7rem",
                    sm: "0.75rem",
                    md: "0.8125rem",
                  },
                  height: {
                    xs: 28,
                    sm: 32,
                    md: 36,
                  },
                  minWidth: {
                    xs: 70,
                    sm: 85,
                    md: 95,
                  },
                  "& .MuiChip-label": {
                    px: 1,
                    whiteSpace: "nowrap",
                  },
                  transition: "all 0.2s ease-in-out",
                  "&:hover": {
                    transform: "translateY(-1px)",
                    boxShadow: 1,
                  },
                }}
              />
            ))}
          </Box>
        </Grid>
        {tabelaVenda?.tipoTabela === "TODOS_PRODUTOS" ? (
          <>
            <Grid
              item
              xs={2}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mt: 1,
              }}
            >
              <RadioGroup
                row
                name="operacao"
                value={tabelaVenda?.operacao}
                onChange={handleOperacaoChange}
                sx={{
                  p: 0,
                  m: 0,
                  width: "100%",
                  justifyContent: "center",
                }}
              >
                <FormControlLabel
                  value="somar"
                  control={<Radio size="small" />}
                  label="Somar"
                  sx={{ m: 0, mr: 1 }}
                />
                <FormControlLabel
                  value="subtrair"
                  control={<Radio size="small" />}
                  label="Subtrair"
                  sx={{ m: 0 }}
                />
              </RadioGroup>
            </Grid>
            <Grid item xs={4}>
              <TextFielDecimalNumbers
                id="fator"
                name="fator"
                label="Fator"
                variant="outlined"
                required
                margin="none"
                value={tabelaVenda?.fator}
                onBlur={handleAjusteChange}
                fullWidth
              />
            </Grid>
          </>
        ) : null}
      </Grid>
      <FiltroProdutosDialog
        open={open}
        setOpen={setOpen}
        filtros={filtros}
        setFiltros={setFiltros}
        resetForm={resetForm}
        handleAjusteChange={handleAjusteChange}
        handleOperacaoChange={handleOperacaoChange}
        tabelaProdutos={tabelaProdutos}
        setTabelaProdutos={setTabelaProdutos}
        tabelaVendaEntity={tabelaVendaEntity}
        tabelaVenda={tabelaVenda}
        setTabelaVenda={setTabelaVenda}
      />
      {tabelaVenda?.tipoTabela !== "TODOS_PRODUTOS" ? (
        <>
          <Divider sx={{ my: 2, border: "1px solid grey", width: "100%" }} />
          <Paper>
            <Tabs
              value={abaValue}
              onChange={async (e, value) => {
                e.persist();
                setAbaValue(value);
              }}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
            >
              <Tab label="PRODUTOS" {...tabProps(0)} />
              <Tab label="CLIENTES" {...tabProps(1)} />
            </Tabs>
          </Paper>
          <CardContent>
            <TabPanel value={abaValue} index={0}>
              {abaValue === 0 ? (
                <TabelaVendaItens
                  produto={produto}
                  setProduto={setProduto}
                  produtos={produtos}
                  setProdutos={setProdutos}
                  tabelaVenda={tabelaVenda}
                  setTabelaVenda={setTabelaVenda}
                  tabelaVendaEntity={tabelaVendaEntity}
                  resetForm={resetForm}
                  tabelaProdutos={tabelaProdutos}
                  setTabelaProdutos={setTabelaProdutos}
                  handleAjusteChange={handleAjusteChange}
                  handleOperacaoChange={handleOperacaoChange}
                  isProdutoEdit={isProdutoEdit}
                  setIsProdutoEdit={setIsProdutoEdit}
                  loading={loading}
                  setLoading={setLoading}
                  setOpen={setOpen}
                  inputErros={inputErros}
                />
              ) : null}
            </TabPanel>
            <TabPanel value={abaValue} index={1}>
              {abaValue === 1 ? (
                <TabelaVendaClientes
                  tabelaClientes={tabelaClientes}
                  resetForm={resetForm}
                  loading={loading}
                  setLoading={setLoading}
                  tabelaVendaEntity={tabelaVendaEntity}
                  setTabelaVenda={setTabelaVenda}
                />
              ) : null}
            </TabPanel>
          </CardContent>
        </>
      ) : null}
      <Loading loading={loading} />
    </AddLayout>
  );
};

export default TabelaVendaView;
